import { render, staticRenderFns } from "./PostFileItemPreview.vue?vue&type=template&id=0d959916&scoped=true&"
import script from "./PostFileItemPreview.vue?vue&type=script&lang=ts&"
export * from "./PostFileItemPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PostFileItemPreview.vue?vue&type=style&index=0&id=0d959916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d959916",
  null
  
)

export default component.exports